import Swiper from 'swiper/bundle';

export const swipers = () => {
  const firstScreenSwiperEl = document.querySelector('.firstScreenSwiper');

  if (firstScreenSwiperEl) {
    const firstScreenSection = firstScreenSwiperEl.closest('.first-screen');
    const firstScreenMobileActions = firstScreenSection?.querySelector('.first-screen__mobile-actions');

    const syncFirstScreenMobileActions = (swiper) => {
      if (!firstScreenSection || !firstScreenMobileActions) return;

      const activeSlide = swiper.slides[swiper.activeIndex];
      const buttons = activeSlide?.querySelector('.first-screen__buttons');

      firstScreenMobileActions.replaceChildren();

      if (!buttons) {
        firstScreenSection.classList.remove('first-screen--mobile-actions-ready');
        return;
      }

      firstScreenMobileActions.append(buttons.cloneNode(true));
      firstScreenSection.classList.add('first-screen--mobile-actions-ready');
    };

    new Swiper(firstScreenSwiperEl, {
      slidesPerView: "auto",
      autoplay: {
        delay: 7000,
        disableOnInteraction: true
      },
      pagination: {
        el: firstScreenSection?.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: firstScreenSwiperEl.querySelector('.swiper-button-prev'),
        nextEl: firstScreenSwiperEl.querySelector('.swiper-button-next'),
      },
      on: {
        init: syncFirstScreenMobileActions,
        slideChange: syncFirstScreenMobileActions,
      },
      breakpoints: {
        678: {
          slidesPerView: 1,
        }
      }
    });
  }

  window.addEventListener("load", () => {
    const headerSwiperEl = document.querySelector('.js-header-swiper');

    if (!headerSwiperEl) return;

    const headerSwiper = new Swiper(headerSwiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      preventClicks: false,
      preventClicksPropagation: false,
    });
  });
  const abonimentsSwiper = new Swiper('.abonimentsSwiper', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    autoplay: {
      delay: 7000,
      disableOnInteraction: true
    },
    navigation: {
      prevEl: ".myswiper__prev",
      nextEl: ".myswiper__next",
    },
    breakpoints: {
      390: {
        slidesPerView: 1.2,
      },
      991: {
        slidesPerView: 2.1,
      },
    }
  });

  const funSwiper = new Swiper('.funSwiper', {
    slidesPerView: 'auto',
    spaceBetween: 16,
    autoplay: {
      delay: 7000,
      disableOnInteraction: true
    },
    breakpoints: {
      991: {
        slidesPerView: 2,
      },
    }
  });

  const vipSwiper = new Swiper('.js-vip-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 7000,
      disableOnInteraction: true
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    breakpoints: {
      /* 390: {
        slidesPerView: 1.2,
      },
      991: {
        slidesPerView: 2,
      }, */
    }
  });
  if (window.innerWidth <= 576) {
    const skatingSwipers = document.querySelectorAll('.js-swiper-skating');
    skatingSwipers.forEach(swiper => {
      const paginationEl = swiper.querySelector('.swiper-pagination');
      new Swiper(swiper, {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    })

  }

  const moreSlider = document.querySelectorAll('.js-modal-more-slider')
  if (moreSlider.length > 0) {
    moreSlider.forEach(slider => {
      const moreSwiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          prevEl: ".myswiper__prev",
          nextEl: ".myswiper__next",
        }
      });
    })
  }
}
const abonimentSliders = document.querySelectorAll('.js-swiper-aboniments');

abonimentSliders.forEach(slider => {
  const slidesCount = slider.querySelectorAll('.swiper-slide').length;

  const prevBtn = slider.querySelector('.aboniments__swiper-btn--prev');
  const nextBtn = slider.querySelector('.aboniments__swiper-btn--next');

  new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 59,

    navigation: slidesCount > 1 ? {
      prevEl: prevBtn,
      nextEl: nextBtn,
    } : false,

    allowTouchMove: slidesCount > 1,
  });
  if (slidesCount <= 1) {
    prevBtn?.style.setProperty('display', 'none');
    nextBtn?.style.setProperty('display', 'none');
  }
});
